import { Typography } from "@repo/design-system";
import type { IMoleculePropertiesSection } from "@/api/moleculeDetails";

interface IPropertiesCardProps {
  section: IMoleculePropertiesSection;
}

export function PropertiesCard({ section }: IPropertiesCardProps) {
  return (
    <div className="flex flex-col gap-3">
      <Typography
        variant="paragraph-l-semibold"
        className="text-contentPrimary">
        {section.displayName}
      </Typography>
      <div className="overflow-hidden rounded-xl border border-borderPrimary bg-backgroundPrimary">
        {section.items.map((item, idx) => (
          <div
            key={item.displayName}
            className={`flex items-start gap-3 px-4 py-3 ${
              idx < section.items.length - 1
                ? "border-b border-borderPrimary"
                : ""
            }`}>
            <Typography
              variant="paragraph-m-semibold"
              className="w-32 flex-shrink-0 text-b700">
              {item.displayName}
            </Typography>
            <Typography
              variant="paragraph-m-regular"
              className="flex-1 break-all text-contentPrimary">
              {item.value || "—"}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
}
